import ChangeNameModal from './change_name_modal'

export default ChangeNameModal